import NavigationPrimaryV2 from './NavigationPrimary.v2'

export default NavigationPrimaryV2
// eslint-disable-next-line import/export
export * from './NavigationPrimary.v2'
